import api from './api';

// Fetch an authenticated endpoint as a blob and trigger a browser download.
// Needed because export endpoints require the Bearer header, so a plain
// <a href> can't be used.
export const downloadFile = async (path, filename, params = {}) => {
  const res = await api.get(path, { params, responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

const dateStamp = () => new Date().toISOString().slice(0, 10);

export const downloadCsv = (path, stem, params = {}) =>
  downloadFile(path, `${stem}-${dateStamp()}.csv`, params);
